import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPrimaryKeyColName } from '../utils/autoformUtils';

const useAutoformTableMetadata = (tableId) => {
    const metadata = useSelector(
        (state) => state.autoform.metadata && state.autoform.metadata.tables.find((table) => table.id === tableId)
    );
    const selectedItem = useSelector(
        (state) => state.autoform.tables[tableId] && state.autoform.tables[tableId].selectedItem
    );
    const dropdownOptionsRaw = useSelector(
        (state) => state.autoform.tables[tableId] && state.autoform.tables[tableId].dropdownOptions
    );

    const primaryKeyColumnName = useMemo(() => metadata && getPrimaryKeyColName(metadata.columns), [metadata]);

    const sortedColumns = useMemo(() => {
        if (metadata) {
            return metadata.columns
                .filter((column) => column.isVisible)
                .sort((prev, next) => (prev.order > next.order ? 1 : -1));
        } else {
            return [];
        }
    }, [metadata]);

    const dropdownOptions = useMemo(
        () =>
            (dropdownOptionsRaw || []).reduce((acc, item) => {
                acc[item.columnId] = item.lookupData;
                return acc;
            }, {}),
        [dropdownOptionsRaw]
    );

    const descriptionColumnName = sortedColumns.length > 0 ? sortedColumns[0].name : '';

    return { metadata, primaryKeyColumnName, sortedColumns, selectedItem, dropdownOptions, descriptionColumnName };
};

export default useAutoformTableMetadata;
